export const getLocalLang = state => {
    return state.localLang
}